"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReasonForPlanDeactivationEnum = void 0;
var ReasonForPlanDeactivationEnum;
(function (ReasonForPlanDeactivationEnum) {
  /** Не указан способ оплаты */
  ReasonForPlanDeactivationEnum["payment_method_is_not_selected"] = "payment_method_is_not_selected";
  /** Ошибка в шлюзе биллинга */
  ReasonForPlanDeactivationEnum["billing_error"] = "billing-error";
  /** Банк отклонил платеж */
  ReasonForPlanDeactivationEnum["bank_declined_payment"] = "bank-declined-payment";
})(ReasonForPlanDeactivationEnum = exports.ReasonForPlanDeactivationEnum || (exports.ReasonForPlanDeactivationEnum = {}));
